import Collections from '../commons/Collections';
import { BaseService } from './BaseService';

export class UtilsService extends BaseService {
  async markGiftCardAsUsed(giftcard_id) {
    try {
      return this.http(`app/giftcard/${giftcard_id}`, 'put', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }
	}
  
  async getGiftCards(company_id) {
    try {
      return this.http(`app/giftcard?company_id=${company_id}`, 'get', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }
	}

	async getProvinces() {
    try {
      return this.http('app/provinces?show_all=1', 'get', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }
	}
	async getZonesByProvince(provinceId) {

    try {
      return this.http(`app/provinces/${provinceId}/zones`, 'get', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }

	}
	async addZone(provinceId, name, latitude, longitude){

    try {
      return this.http(`app/provinces/${provinceId}/zones`, 'post', {
				name,
        latitude, 
        longitude
			});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }

	}
	async dropZone(provinceId, zoneId){

    try {
      return this.http(`app/provinces/${provinceId}/zones/${zoneId}`, 'delete', {});
    } catch (error) {
      return {
        ok: false,
        message: error.message
      }
    }
	}
	async getZones(provinceId){
		const path = 	`${Collections.province}/${provinceId}/${Collections.zones}`;
		const list = await this.getCollectionRef(path).get();
		return list.docs.map(d => {
		  return {
				id: d.id,
				name: d.data().name,
				provinceId: provinceId,
				selected: false
			};
		});
	}

  async getDistanceConfig(){
    return this.http('app/distance-config', 'get');
  }

  async saveDistanceConfig(data){
    return this.http('app/distance-config', 'post', data);
  }

  async getCompanyAPIInfo(companyId){
    return this.http(`app/companies/${companyId}/api-info`, 'get');
  }

  async saveCompanyAPIInfo(companyId, data){
    return this.http(`app/companies/${companyId}/api-info`, 'post', data);
  }

  async companyRunAPIProducts(companyId){
    return this.http(`app/companies/${companyId}/run-api-products`, 'post', {});
  }

  async getOnBoarding(){
    return this.http(`app/onboarding`, 'get');
  }

  async getOneOnBoarding(version){
    return this.http(`app/onboarding/${version}`, 'get');
  }
  
  async saveOnBoarding(version, slides){
    return this.http(`app/onboarding/${version}`, 'post', {slides});
  }

  async getConvertionRateServiceFee(){
    return this.http('app/convertion-rate_service-fee', 'get');
  }

  async saveConvertionRateServiceFee(data){
    return this.http('app/convertion-rate_service-fee', 'post', data);
  }

}
